import deliveryDetailsActions from '../actions/DeliveryDetailsActions';

export default function (state = {}, action) {
    switch (action.type) {
    case deliveryDetailsActions.types.LOAD_DELIVERY_DETAILS_SUCCESS:
        return Object.assign({}, action.deliveryDetails);
    default:
        return state;
    }
}
